var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02246 4.94794H0.959961V9.07294L1.64746 10.4479H3.70996L3.02246 9.07294V4.94794ZM1.64746 1.51044H3.70996V3.57294H1.64746V1.51044ZM4.39746 9.07294L5.77246 11.8229H7.14746L8.52246 9.07294V4.94794H4.39746V9.07294ZM5.08496 0.822937H7.83496V3.57294H5.08496V0.822937ZM9.89746 4.94794V9.07294L9.20996 10.4479H11.2725L11.96 9.07294V4.94794H9.89746ZM9.20996 1.51044H11.2725V3.57294H9.20996V1.51044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquad);
export default __webpack_public_path__ + "static/media/squad.d6f092c3b14ea67ec09e4473552c67bd.svg";
export { ForwardRef as ReactComponent };